<template>
  <div class="wt-overlay-asset-page">
    <layout-general>
      <layout-header
        slot="header"
        :hide-back="standalone"
        :hide-ian="standalone"
      >
        <div class="wt2-overlay-assets-carousel wt2-sg">
          <wt-carousel-gallery
            v-if="overlayTracks.length > 1"
            :bus="bus"
            :offset-left="offsetLeft"
          >
            <div
              class="-overlay-asset-carousel"
              :class="{ '-center': overlayTracks.length <= 7 }"
            >
              <wt-lightbox-asset
                v-for="track in overlayTracks"
                :key="track.guid"
                :asset="track"
                :overlay="true"
                @click.native="selectOverlayAsset(track)"
                ref="overlayTracks"
                :class="{ '-selected': activeGuid === track.guid }"
              />
            </div>
          </wt-carousel-gallery>
        </div>
      </layout-header>

      <overlay-asset-top-bar slot="top" :stage-rect="stageRect" />
      <left-bar slot="left" />
      <main-stage slot="main" ref="mainStage" />
      <apply-cancel slot="footer" />
    </layout-general>
  </div>
</template>

<script>
import LayoutGeneral from 'AssetEditor/layouts/LayoutGeneral.vue';
import bus from 'v/AssetEditor/AssetEditorEventBus';
import LayoutHeader from 'AssetEditor/layouts/LayoutHeader.vue';
import MainStage from 'AssetEditor/functionality/Stage/MainStage.vue';
import OverlayAssetTopBar from 'AssetEditor/functionality/OverlayAsset/OverlayAssetTopBar.vue';
import LeftBar from 'AssetEditor/functionality/OverlayAsset/OverlayAssetLeftBar.vue';
import ApplyCancel from 'AssetEditor/functionality/OverlayAsset/OverlayAssetApplyCancel.vue';
import { mapMutations, mapState } from 'vuex';

export default {
  components: {
    LayoutGeneral,
    LeftBar,
    ApplyCancel,
    LayoutHeader,
    MainStage,
    OverlayAssetTopBar,
  },

  data() {
    return {
      bus,
      offsetLeft: 0,
      stageRect: null,
    };
  },

  mounted() {
    setTimeout(() => {
      this.stageRect = this.$refs.mainStage.$el.getBoundingClientRect();
      if (this.$refs.overlayTracks) {
        this.offsetLeft =
          this.$refs.overlayTracks[this.selectedIndex].$el.offsetLeft;
      }
    }, 400);
  },

  computed: {
    ...mapState('assetEditor', {
      standalone: 'overlayTrackStandAlone',
      activeGuid: 'activeOverlayTrackGuid',
      overlayTracks: (state) => state.workModel.overlayTracks,
    }),

    selectedIndex() {
      return this.overlayTracks.findIndex((t) => t.guid === this.activeGuid);
    },
  },

  beforeDestroy() {
    this.resetTempTracks();
  },

  methods: {
    ...mapMutations('assetEditor', [
      'setActiveOverlayTrack',
      'resetTempTracks',
    ]),

    selectOverlayAsset(track) {
      this.setActiveOverlayTrack(track.guid);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'style_guide/_sg_variables.scss';
.wt2-overlay-assets-carousel {
  .wt-lightbox-asset {
    overflow: visible;
    .-inner {
      outline: rgba(0, 0, 0, 0.1) 1px solid;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }
  }
  height: 100%;
  width: calc(100% - 100px);
  margin: auto;
  .-arrow {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
    width: 30px;
    height: 30px;
    .wticon {
      font-weight: bold;
    }
  }
  .-arrow-right {
    right: 0;
  }
  .-arrow-left {
    left: 0;
  }

  .-border-layer {
    cursor: pointer;
    border: none;
  }
}

.-overlay-asset-carousel {
  display: flex;
  align-items: center;
  &.-center {
    justify-content: center;
  }
  user-select: none;
  height: 100%;
  > div {
    margin-right: 10px;
    flex-shrink: 0;
    width: 98px;
    height: 58px;
    background-color: transparent;
    transition: all 0.1s ease-in;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    border: 1px rgba($color-black, 0.05);
    &::after {
      transition: border 0.1s ease-in;
      border: 0 solid transparent;
      content: '';
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      position: absolute;
      z-index: 0;
    }
    &:hover {
      border: 2px solid #06a9f4;
      &::after {
        border: 2px solid #fff;
      }
      .-inner {
        box-shadow: none;
      }
    }
    &.-selected {
      box-shadow: none;
      width: 115px;
      height: 64px;
      border: 2px solid #06a9f4;
      .wt-asset-icons-box {
        bottom: 3px;
        left: 3px;
      }
      &::after {
        border: 4px solid #fff;
      }
      .-inner {
        box-shadow: none;
      }
    }
  }
}
</style>
